// extracted by mini-css-extract-plugin
export default {"container":"LinkPage_container__lvyLJ","sidebar":"LinkPage_sidebar__P3Rg0","chatButton":"LinkPage_chatButton__JvMCi"};